import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';

import Wrapper from '../elements/wrapper';
import { media, TransitonMixn } from '../helpers';

import Wave from '../../images/waves/home-top-wave.inline.svg';

const BottomWaveContainer = styled.div`
    background-color: #f2f0eb;
    /* padding-bottom: 10vh; */
    z-index: 10;
    position: relative;
    margin-bottom: -10vh;
    .svg-container {
        background-color: #f2f0eb;

        svg {
            width: 100%;
            height: auto;
            path {
                fill: #fff;
                opacity: 1;
            }
        }
    }
    .wave-cta-wrapper {
        padding: 100px 0 0;
        max-width: 100vw;
        ${media.medium`max-width: 90vw; padding: 100px 0;`}
        > .content-container {
            text-align: center;
            padding: 0 20px;
            ${media.medium`padding: 0;`}
            h3 {
                font-size: 4rem;
                color: #000;
                letter-spacing: -1px;
                margin: 0 0 20px;
                font-weight: 800;
                font-family: neue-kabel, sans-serif;
            }

            p {
                font-size: 1rem;
                max-width: 550px;
                margin: 0 auto 30px;
                line-height: 1.5;
            }

            .btn-container {
                padding-bottom: 7vh;
                ${media.medium`padding-bottom: 0vh;`}
                a {
                    color: #fff;
                    background-color: #f74d33;
                    text-decoration: none;
                    font-weight: bold;
                    font-size: 1.1rem;
                    border-radius: 5px;
                    line-height: 1;
                    display: inline-block;
                    padding: 20px 0;
                    max-width: 225px;
                    width: 100%;
                    font-weight: 800;
                    font-family: neue-kabel, sans-serif;
                }
            }
        }
    }
`;

const BottomWave = ({ content }) => {
    const { waveButton, waveTitle, waveCaption } = content || {};
    return (
        <BottomWaveContainer>
            <div className="svg-container">
                <Wave />
            </div>
            <Wrapper className="wave-cta-wrapper">
                <div className="content-container">
                    <h3>{waveTitle}</h3>
                    <p>{waveCaption}</p>
                    <div className="btn-container">
                        {waveButton.url && (
                            <Link to={waveButton.url}>{waveButton.title}</Link>
                        )}
                    </div>
                </div>
            </Wrapper>
        </BottomWaveContainer>
    );
};

export default BottomWave;
